var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAnimalsBeef(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26_1320)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.1991 37.1242V28.3962L0.00390625 22.3338V37.1258L2.1991 37.1242ZM23.9058 28.9474V37.1258H25.8572L26.9052 28.9474H23.9058Z",
    fill: "#7A491F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4073 20.6975V15.2173H36.8713V17.9869H43.3435C44.2595 17.9869 45 17.2417 45 16.3242V15.2514L41.8159 12.0533V10.9635L40.0616 9.20299L42.4089 8.28858V7.00003H37.7236C37.5249 7.00044 37.3282 7.04 37.1448 7.11647C36.9614 7.19293 36.7948 7.30479 36.6547 7.44566C36.5145 7.58652 36.4035 7.75363 36.328 7.93742C36.2525 8.12122 36.2139 8.31809 36.2146 8.5168L31.0138 11.1172H5.85905C4.31704 11.1219 2.83867 11.7325 1.74265 12.8172C0.646637 13.9018 0.0207799 15.3738 1.5319e-05 16.9157C-0.00153715 17.6702 0.114899 18.3486 0.35398 19.0162L6.92094 37.1258H9.25897L7.31682 31.7604L9.98707 24.3908C10.1687 23.8925 10.2557 23.3817 10.2557 22.8803H11.7196V26.6885C12.5813 27.1884 13.5826 27.474 14.6476 27.474H28.3699V37.1242H30.3183L32.293 26.4075C33.2488 25.7932 34.0348 24.9485 34.5787 23.951C35.1226 22.9535 35.407 21.8352 35.4057 20.6991L35.4073 20.6975Z",
    fill: "#7A491F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26_1320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAnimalsBeef);
export default __webpack_public_path__ + "static/media/ic-animals-beef.da0fd655d16dc4c1e872e4107feb80ca.svg";
export { ForwardRef as ReactComponent };